import { Component, ViewChild } from "@angular/core";
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { RefineryBalanceService } from "../refinery-balance.service";
import { DxDataGridComponent } from "devextreme-angular";
import { Workbook } from "exceljs";
import saveAs from 'file-saver';
import { exportDataGrid } from "devextreme/excel_exporter";
import { Router } from "@angular/router";
import { SharedService } from "src/app/services/SharedService";

@Component({
    selector: 'refinery-balance',
    templateUrl: './refinery-balance.component.html',
    styleUrls: ['./refinery-balance.component.scss']
})



export class RefineryBalanceComponent {

    refineryBalances: any[];
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    readonly allowedPageSizes = [50, 100, 200];
    isLoadPanelVisible: boolean = false;

    constructor(private notificationService: NotificationService, private router: Router, private refineryBalanceService: RefineryBalanceService
        , private sharedSvc: SharedService) {
        this.isLoadPanelVisible = true;
        this.refineryBalanceService.GetRefineryBalances().subscribe({
            next: refineryBalances => {
                this.refineryBalances = refineryBalances;
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Refinery Balances", error);
            }
        });
    }

    resetFilters() {
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSorting();
    }

    exportExcel(e) {
        this.dataGrid.instance.columnOption('siteId', 'visible', true);
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.dataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'RefineryBalance.xlsx');
                });
        }).then(() => {
            this.dataGrid.instance.columnOption('siteId', 'visible', false);
        });
        e.cancel = true;
    }

    redirectToSite(e) {
        this.sharedSvc.previousRouteToEditSite = "refinerybalance/";
        this.router.navigate(["/editsite/" + e.currentTarget.text]);
        return false;        
    }
}